const paginationMergeResponse = <ListItem>(
  currentCacheData: PaginationList<ListItem>,
  responseData: PaginationList<ListItem>
): void => {
  currentCacheData.items.push(...responseData.items);
  currentCacheData.pageCount = responseData.pageCount;
  currentCacheData.currentPage = responseData.currentPage;
  currentCacheData.itemsCount = responseData.itemsCount;
};

export default paginationMergeResponse;
